import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProjectReadyStatusDirective } from './directives/project-ready-status.directive';
import { MiscModule } from 'projects/core/src/public-api';
import { ChecklistBlockComponent } from './view/blocks/checklist-block/checklist-block.component';
import { AccordionModule } from 'primeng/accordion';
import { ActivityStatusComponent } from './view/activity-status/activity-status.component';
import { GmapsComponent } from './view/gmaps/gmaps.component';
import { PdfPreviewDialogComponent } from './view/pdf-preview-dialog/pdf-preview-dialog.component';
import { ProjectActivityDialogComponent } from './view/project-activity-dialog/project-activity-dialog.component';
import { EditPunchItemComponent } from './view/edit-punch-item/edit-punch-item.component';
import { AgmCoreModule } from '@agm/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { SelectButtonModule } from 'primeng/selectbutton';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { CalendarModule } from 'primeng/calendar';
import { FileUploadModule } from 'primeng/fileupload';
import { ProjectPanelComponent } from './view/project-panel/project-panel.component';
import { CustomerBlockComponent } from './view/blocks/customer-block/customer-block.component';
import { MapsBlockComponent } from './view/blocks/maps-block/maps-block.component';
import { FilesBlockComponent } from './view/blocks/files-block/files-block.component';
import { ActivitiesBlockComponent } from './view/blocks/activities-block/activities-block.component';
import { AddCommentComponent } from './view/blocks/activities-block/add-comment/add-comment.component';
import { EditCommentComponent } from './view/blocks/activities-block/edit-comment/edit-comment.component';
import { ProjectInfoBlockComponent } from './view/blocks/project-info-block/project-info-block.component';
import { ProjectStatusEditComponent } from './view/project-status-edit/project-status-edit.component';
import { PaymentStatusEditComponent } from './view/payment-status-edit/payment-status-edit.component';
import { ComplexityEditComponent } from './view/complexity-edit/complexity-edit.component';
import { AddPunchItemComponent } from './view/add-punch-item/add-punch-item.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CustomerMiscModule } from '../customer/customer-misc.module';
import { DropdownModule } from 'primeng/dropdown';
import { TooltipModule } from 'primeng/tooltip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DueDateComponent } from './view/blocks/project-info-block/due-date/due-date.component';
import {
  ProjectManagerEditComponent
} from './view/blocks/project-info-block/project-manager-edit/project-manager-edit.component';
import { UserInfoPopupComponent } from '../profile/view/user-info-popup/user-info-popup.component';
import { HistoryBlockComponent } from './view/blocks/history-block/history-block.component';
import { NotificationModule } from '../notification/notification.module';
import { ProjectTypeEditComponent } from './view/project-type-edit/project-type-edit.component';
import { UserMentionsModule } from '../mentions/user-mentions.module';
import { MentionModule } from 'angular-mentions';
import { CustomerSearchComponent } from './view/customer-search/customer-search.component';
import { FinishVendorSearchComponent } from './view/finish-vendor-search/finish-vendor-search.component';
import { AddUserPopupComponent } from '../profile/view/add-user-popup/add-user-popup.component';
import { ProjectMembersComponent } from './view/project-panel/project-members/project-members.component';
import { AlertsRowComponent } from './view/row-block/alerts-row/alerts-row.component';
import { LocationSearchComponent } from './view/location-search/location-search.component';
import {
  ProjectActivitiesBlockComponent
} from './view/blocks/project-activities-block/project-activities-block.component';
import {
  HistoryNotificationComponent
} from './view/blocks/history-block/history-notification/history-notification.component';
import {
  SubHistoryNotificationComponent
} from './view/blocks/history-block/history-notification/sub-history-notification/sub-history-notification.component';
import { SendFeedBackDialogComponent } from '../feedback/view/send-feed-back-dialog/send-feed-back-dialog.component';
import { ActivityFilesComponent } from './view/blocks/project-activities-block/activity-files/activity-files.component';
import { PunchItemFilesComponent } from './view/punch-item-files/punch-item-files.component';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRippleModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTabsModule } from '@angular/material/tabs';
import { InputTextModule } from 'primeng/inputtext';
import { InputMaskModule } from 'primeng/inputmask';
import { InputSwitchModule } from 'primeng/inputswitch';
import {
  DrawingApprovedStatusEditComponent
} from './view/drawing-approved-status-edit/drawing-approved-status-edit.component';
import { CheckboxModule } from 'primeng/checkbox';
import { ReplyCommentComponent } from './view/blocks/activities-block/reply-comment/reply-comment.component';
import { CabinetsBlockComponent } from './view/blocks/cabinets-block/cabinets-block.component';
import {
  CabinetsStatusesBlockComponent
} from './view/blocks/cabinets-block/cabinets-statuses-block/cabinets-statuses-block.component';
import { ImageGalleryCarouselComponent } from './view/image-gallery-carousel/image-gallery-carousel.component';
import { GalleriaModule } from 'primeng/galleria';

import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

import { CabinetsMiscModule } from '../cabinets/cabinets-misc.module';
import { TasksBlockComponent } from './view/blocks/tasks-block/tasks-block.component';
import { HomePageModule } from 'projects/desktop/src/app/modules/home-page/home-page.module';
import { SystemAlertsModule } from 'projects/desktop/src/app/modules/alerts/system-alerts.module';
import { ClientMessagesBlockComponent } from './view/blocks/client-messages-block/client-messages-block.component';
import { ClientNfsModule } from 'projects/desktop/src/app/view/notification/notification.module';
import {
  CreateMessageDialogComponent
} from './view/blocks/client-messages-block/create-message-dialog/create-message-dialog.component';
import { LabelsPrintDialogComponent } from './view/project-panel/labels-print-dialog/labels-print-dialog.component';
import { ListboxModule } from 'primeng/listbox';
import { CheckItemIconsComponent } from './view/blocks/checklist-block/check-item-icons/check-item-icons.component';
import { QBModule } from '../qb/qb.module';
import { IvyGalleryModule } from 'angular-gallery';
import { GalleryModule } from 'ng-gallery';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { PunchItemTagsComponent } from './view/punch-item-tags/punch-item-tags.component';
import { InputNumberModule } from 'primeng/inputnumber';
import { DocusignStatusEditComponent } from './view/docusign-status-edit/docusign-status-edit.component';
import { ContactInfoBlockComponent } from './view/blocks/contact-info-block/contact-info-block.component';
import 'hammerjs';
import {
  ActivityRequestsComponent
} from './view/project-activity-dialog/activity-requests/activity-requests.component';
import {
  QuotesEmailDialogComponent
} from './view/project-activity-dialog/activity-requests/quotes-email-dialog/quotes-email-dialog.component';
import {
  BlockLateralArrowNavigationDirective
} from 'projects/app-misc/src/app/modules/project-misc/directives/block-lateral-arrow-navigation.directive';
import { ProjectCopyDialogComponent } from './view/project-panel/project-copy-dialog/project-copy-dialog.component';
import { InstallPmntStatusEditComponent } from './view/install-pmnt-status-edit/install-pmnt-status-edit.component';
import {FilesMiscModule} from '../files-misc/files-misc.module';
import {MultiSelectModule} from 'primeng/multiselect';

@NgModule({
  declarations: [
    ProjectReadyStatusDirective,
    ChecklistBlockComponent,
    ActivityStatusComponent,
    GmapsComponent,
    AddPunchItemComponent,
    PdfPreviewDialogComponent,
    ProjectActivityDialogComponent,
    ComplexityEditComponent,
    EditPunchItemComponent,
    ProjectPanelComponent,
    CustomerBlockComponent,
    MapsBlockComponent,
    FilesBlockComponent,
    ActivitiesBlockComponent,
    AddCommentComponent,
    EditCommentComponent,
    ProjectInfoBlockComponent,
    ProjectStatusEditComponent,
    PaymentStatusEditComponent,
    DueDateComponent,
    ProjectManagerEditComponent,
    UserInfoPopupComponent,
    AddUserPopupComponent,
    HistoryBlockComponent,
    ProjectTypeEditComponent,
    CustomerSearchComponent,
    FinishVendorSearchComponent,
    ProjectMembersComponent,
    AlertsRowComponent,
    LocationSearchComponent,
    ProjectActivitiesBlockComponent,
    HistoryNotificationComponent,
    SubHistoryNotificationComponent,
    SendFeedBackDialogComponent,
    ActivityFilesComponent,
    PunchItemFilesComponent,
    DrawingApprovedStatusEditComponent,
    ReplyCommentComponent,
    CabinetsBlockComponent,
    CabinetsStatusesBlockComponent,
    ImageGalleryCarouselComponent,
    TasksBlockComponent,
    ClientMessagesBlockComponent,
    CreateMessageDialogComponent,
    LabelsPrintDialogComponent,
    CheckItemIconsComponent,
    PunchItemTagsComponent,
    DocusignStatusEditComponent,
    ContactInfoBlockComponent,
    ActivityRequestsComponent,
    QuotesEmailDialogComponent,
    BlockLateralArrowNavigationDirective,
    ProjectCopyDialogComponent,
    InstallPmntStatusEditComponent

  ],
    imports: [
        FilesMiscModule,
        CommonModule,
        FormsModule,
        MatInputModule,
        ReactiveFormsModule,
        TableModule,
        MatDialogModule,
        MatRippleModule,
        MatButtonModule,
        MatFormFieldModule,
        MatSelectModule,
        MatProgressBarModule,
        MatTabsModule,
        SelectButtonModule,
        OverlayPanelModule,
        DropdownModule,
        CalendarModule,
        FileUploadModule,
        MatIconModule,
        MatProgressSpinnerModule,
        MiscModule,
        CustomerMiscModule,
        AccordionModule,
        AutoCompleteModule,
        ConfirmDialogModule,
        TooltipModule,
        NotificationModule,
        MentionModule,
        UserMentionsModule,
        InputTextModule,
        InputMaskModule,
        InputSwitchModule,
        CheckboxModule,
        GalleriaModule,
        NgxExtendedPdfViewerModule,
        CabinetsMiscModule,
        HomePageModule,
        SystemAlertsModule,
        ClientNfsModule,
        ListboxModule,
        QBModule,
        IvyGalleryModule,
        GalleryModule,
        DragDropModule,
        InputNumberModule,
        AgmCoreModule.forRoot({
            // apiKey: environment.googleMapsApiKey
            apiKey: 'AIzaSyDDSKJagebcLE37FkuI_uj-UWoo8QmtPOU'
        }),
        MultiSelectModule
    ],
    exports: [
        ProjectReadyStatusDirective,
        ChecklistBlockComponent,
        ActivityStatusComponent,
        GmapsComponent,
        AddPunchItemComponent,
        PdfPreviewDialogComponent,
        ImageGalleryCarouselComponent,
        ProjectActivityDialogComponent,
        ComplexityEditComponent,
        EditPunchItemComponent,
        PunchItemTagsComponent,
        ProjectPanelComponent,
        CustomerBlockComponent,
        MapsBlockComponent,
        FilesBlockComponent,
        ActivitiesBlockComponent,
        ProjectInfoBlockComponent,
        HistoryBlockComponent,
        ClientMessagesBlockComponent,
        TasksBlockComponent,
        AlertsRowComponent,
        LocationSearchComponent,
        SendFeedBackDialogComponent,
        ProjectActivitiesBlockComponent,
        DrawingApprovedStatusEditComponent,
        CabinetsBlockComponent,
        CabinetsStatusesBlockComponent,
        ContactInfoBlockComponent,
        CheckItemIconsComponent,
        BlockLateralArrowNavigationDirective,
        SubHistoryNotificationComponent
    ],
  entryComponents: [
    PdfPreviewDialogComponent,
    ImageGalleryCarouselComponent,
    ProjectActivityDialogComponent,
    SendFeedBackDialogComponent,
    CreateMessageDialogComponent,
    LabelsPrintDialogComponent
  ]

})
export class ProjectMiscModule {
}
